"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walk = void 0;
const walk = (node) => {
    const stack = [node];
    return () => {
        const node = stack.pop();
        if (!node)
            return;
        if (typeof node === 'string')
            return node;
        for (let i = node.length - 1; i >= 2; i--)
            stack.push(node[i]);
        return node;
    };
};
exports.walk = walk;
